import script from "./UsuarioPasswordEstablecer.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuarioPasswordEstablecer.vue?vue&type=script&setup=true&lang=js"

import "./UsuarioPasswordEstablecer.vue?vue&type=style&index=0&id=c55245dc&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c55245dc"]])

export default __exports__